export const appReducer = (state = {}, action: any): any => {
  switch (action.type) {
    default:
      return state;
  }
};
